import { getBookingDetailsPageLink } from 'lib/links';
import useDetailsBooking from 'hooks/useDetailsBooking';
import { useTitleOnMount } from 'lib/hooks';
import PageHeader from 'components/PageHeader';
import ChangeDatesRequestFlow from './ChangeDatesRequestFlow';
import { useCanRequestAmendDatesGuard } from './hooks/useCanRequestAmendDatesGuard';
import ChangeDatesRequestFlowProvider from './ChangeDatesRequestFlowProvider';

const ChangeDatesRequestPage = () => {
  const { booking } = useDetailsBooking();
  const reference = booking.reference;

  useCanRequestAmendDatesGuard(booking);
  useTitleOnMount(`Date Change Request for ${reference}`);

  return (
    <>
      <PageHeader
        title="Change booking"
        bookingRef={reference}
        showCloseSessionButton={!booking.account}
        backLinkUrl={getBookingDetailsPageLink(booking.id)}
        backLinkTitle={'Manage your booking'}
      />
      <ChangeDatesRequestFlowProvider>
        <ChangeDatesRequestFlow />
      </ChangeDatesRequestFlowProvider>
    </>
  );
};

export default ChangeDatesRequestPage;
